<div id="{{id}}" class="{{#if hideCriteriaFirstTime}}hidden{{/if}}">
    <field-item item="criteriaFormModel">
        <field-hcombo id="criteria-selectByType" name="type" label="" {options}="typeOptions"></field-hcombo>

        <uda-list of="users" name="user" label-key="uda.user.severalSelected" {visible}="states.user"
                  class="inlineGroup"></uda-list>
    </field-item>
</div>
